<div class="title">{{ title }}</div>
<div class="subtitle">{{ description }}</div>

<div class="settings">
  <ng-container *ngIf="!loading; else loadingContent">
    <div class="row center">
      <mat-button-toggle-group name="availabilityIncrements" [formControl]="durationFormControl">
        <mat-button-toggle class="setting-toggle" *ngFor="let option of options" [value]="option.seconds">
          {{ option.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div class="row center">
      <p class="hint">{{ hint }}</p>
    </div>
  </ng-container>
  <ng-template #loadingContent>
    <div class="row center">
      <div
        *ngFor="let option of options"
        class="increment-box stencil-shimmer increment-box__loading--stencil-shimmer"
      >
        <div class="invisible">
          <span>{{ option.label }}</span>
        </div>
      </div>
    </div>
    <div class="row center">
      <p class="hint">{{ hint }}</p>
    </div>
  </ng-template>
</div>
